import { SpriteProvider } from '@frontends/ds-icons';
import { GlobalLoading } from '@frontends/feature-tv-parts';
import { useLayoutEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ControlPanelWidget } from './components/controlPanel';
import { SessionStatisticWidget } from './components/sessionStatistic';
import { TradingViewWidget } from './components/tradingView';
import { AccountProvider } from './context/account';
import { AuthProvider } from './context/auth';
import { PreferencesGateway } from './context/preferences';
import { useEntityConfig } from './hooks/useEntityConfig';
import i18n from './i18n';

export function App(): React.JSX.Element {
  const config = useEntityConfig();

  useLayoutEffect(() => {
    document.title = config.VITE_APPLICATION_TITLE;
  }, [config.VITE_APPLICATION_TITLE]);

  return (
    <I18nextProvider i18n={i18n}>
      <SpriteProvider>
        <PreferencesGateway>
          <GlobalLoading>
            <AuthProvider>
              <AccountProvider>
                <ControlPanelWidget />
                <SessionStatisticWidget />
                <TradingViewWidget />
              </AccountProvider>
            </AuthProvider>
          </GlobalLoading>
        </PreferencesGateway>
      </SpriteProvider>
    </I18nextProvider>
  );
}
